import React, {useContext, useState, useEffect} from 'react'
import t from 'helpers/I18n'
import {useParams} from "react-router";
import {useHistory} from "react-router-dom";

import {AppDataContext} from 'contexts/app-data'
import { personal_info_steps_config, legal_info_steps_config, pro_info_steps_config } from "steps/steps-config";
import { BASE_URL } from '../../env';
import getCookie from '../../functions/getcookie';
import deleteCookie from '../../functions/deleteCookie';

import StepsWrapper from "steps/steps-wrapper";
import EndFlow from "steps/end-flow";

import IdentityStep from "steps/personal-data/01-identity-step";
import Email from "steps/personal-data/02-email-step";
import Phone from "steps/personal-data/03-telephone-step";
import BelgianResidence from "steps/personal-data/04-belgian-residence-step";
import LegalAddress from "steps/personal-data/05-legal-address-step";
import DateOfBirth from "steps/personal-data/07-date-of-birth-step";
import PlaceOfBirth from "steps/personal-data/08-place-of-birth-step";
import Nationality from "steps/personal-data/09-nationality-step";
import NationalNumber from "steps/personal-data/10-national-number-step";
import MaritalStatus from "steps/personal-data/11-marital-status-step";
import SummaryPersoStep from './personal-data/personal-info-summary';
import getStep from '../../helpers/getStep';


const Steps = () => {
    const {state, dispatch} = useContext(AppDataContext)
    const [error, setError] = useState([])
    const history = useHistory();
    const getKeyByValue = (object, value) => ( Object.keys(object).find(key => object[key].step_position === value))
    const getDataFromContext = (step_ID) => (state.raw_personal_data[step_ID])
    const { id, locale } = useParams()
    const lang = localStorage.getItem('language')

    const base_URL = `${BASE_URL}/onboarding-entrepreneur-front/v1/step`
    
    const fetchOption = {
        credentials: "include",
        mode: "cors",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',            
        }
    }

    const errorsHandeling = function (response) {
         setError(JSON.parse(response.message))
    }

    const _step_service = function ({ step_ID, setIsLoading, next_step }) {
        const fetch_url = base_URL
        const stepFieldData = getDataFromContext(step_ID)
        let data = []

        for (let field in stepFieldData) {
            !field.startsWith("__") && 
            data.push({
                "fieldId": field,
                "fieldValue": stepFieldData[field] 
            })
        }

        setIsLoading(true)
        const fetch_init = {
            ...fetchOption,
            method: 'POST',
            body: JSON.stringify(
            [...data]
            )
        }

        fetch(fetch_url, fetch_init).catch(error => {
                    window.location.href = (`${window.location.origin}/${lang.toLowerCase()}/500`)
            
        }).then(response => {
            if (response.status === 200) return {status: 200}
            if (response.status === 400) return response.json()
        }).then(response => {
            if (response.status === 400 ) {
                if (getCookie('sf-payload-ident')) {
                    deleteCookie()
                    // history.push('/')
                    // window.location.href = window.location.origin
                    window.location.href = (`${window.location.origin}/${lang.toLowerCase()}/500`)
                } else if (getCookie('sf-payload-ident') === undefined) (
                    // window.location.href = window.location.origin
                    window.location.href = (`${window.location.origin}/${lang.toLowerCase()}/500`)
                    // history.push('/')
                )
                errorsHandeling(response)
                setIsLoading(false)
            }
            if (response.status === 200) {
                setTimeout(function(){
                    // setIsLoading(false)
                    history.push(next_step)
                    
                }, 100)
            }
        })
    }

    const _get_step_service = async function (fieldArr) {
        const fetch_url = base_URL
        const response = await Promise.all(
            fieldArr.map((field) => fetch(`${fetch_url}/${field.id}`,fetchOption))
        );
            return response.every((response) => response.ok === true) &&
            (await Promise.all(response.map((res) => res.json())))
    }

    const setDataToContext = (step_ID, step_URL, name, value) => {
            dispatch({
                type: 'SET_RAW_PERSONAL_DATA',
                step: {step_ID, step_URL, step_position},
                value: {[name] : value}
            })
        }

    const steps = personal_info_steps_config.steps
    const step_info = steps[id]
    

    if (step_info === undefined) {
        window.location.href = (`${window.location.origin}/${lang.toLowerCase()}/404`);
    }

    const {step_position, step_ID, step_URL, step_form} = step_info
    const total_steps = Object.keys(steps).length + Object.keys(legal_info_steps_config.steps).length + Object.keys(pro_info_steps_config.steps).length
    const loaded = id === "end-flow" ? 0.1 :(step_position / total_steps) * 100
    const stepGroupTitle = id === 'end-flow' ? t("exit_messages.header_title") : t('general.personal_info')
    const step_URL_baseName = `/${locale}/steps/`
    const step_init = {
        getStep,
        step_ID,
        step_position,
        step_form,
        error,
        step_URL : step_URL_baseName + step_URL,
        next_step : step_position >= 1 && step_position < total_steps ? `${step_URL_baseName}${steps[getKeyByValue(steps, step_position + 1)].step_URL}` : "/",
        _step_service,
        _get_step_service,
        getDataFromContext,
        setDataToContext
    }

    useEffect(() => {
        
        getStep([
            "first_name", "last_name",
            "email", "optin_email",
            "internal_mobile_country_code", "internal_mobile_phone_number", "optin_mobile", "internal_mobile_country_calling_code",
            "street", "house_number", "box", "zip_code", "city",
            "birth_country", "birth_place", "internal_postal_input", "internal_placeOfBirth_country",
            "nationality", "internal_nationality_country",
            "income_source_other",
            "transaction_id"
        ]).then(res => { 
            // ["first_name", "last_name"].forEach(id => setDataToContext("identity", "", id, res[id])); 

            res["email"] !== "NULL" && setDataToContext("email", "", "email", res["email"]);
            res["optin_email"] !== "-1" && setDataToContext("email", "", "optin_email", Number(res["optin_email"]));

            res["internal_mobile_country_code"] !== "NULL" && setDataToContext("phone", "", "internal_mobile_country_code", res["internal_mobile_country_code"]);
            res["internal_mobile_phone_number"] !== "NULL" && setDataToContext("phone", "", "internal_mobile_phone_number", res["internal_mobile_phone_number"]);
            res["optin_mobile"] !== "-1" && setDataToContext("phone", "", "optin_mobile", Number(res["optin_mobile"]));
            res["internal_mobile_country_calling_code"] !== "null" && setDataToContext("phone", "", "internal_mobile_country_calling_code", res["internal_mobile_country_calling_code"]);
                
            ["street", "house_number", "box", "zip_code", "city"].forEach(id => setDataToContext("legalAddress", "", id, res[id]));

            res["birth_country"] !== "NULL" && setDataToContext("placeOfBirth", "", "birth_country", res["birth_country"]);
            res["birth_place"] !== "NULL" && setDataToContext("placeOfBirth", "", "birth_place", res["birth_place"]);
            res["internal_postal_input"] !== "null" && setDataToContext("placeOfBirth", "", "internal_postal_input", res["internal_postal_input"]);
            res["internal_placeOfBirth_country"] !== "null" && setDataToContext("placeOfBirth", "", "internal_placeOfBirth_country", res["internal_placeOfBirth_country"]);

            res["nationality"] !== "null" && setDataToContext("nationality", "", "nationality", res["nationality"]);
            res["internal_nationality_country"] !== "null" && setDataToContext("nationality", "", "internal_nationality_country", JSON.parse(res["internal_nationality_country"]));

            res["income_source_other"] !== "NULL" && setDataToContext("income_source_other", "", "income_source_other", JSON.parse(res["income_source_other"]));
            window.digitalData.onlineSalesAndServiceFlows.transactionID = res["transaction_id"] !== "NULL" ? res["transaction_id"] : "" ;
        })
        
    }, [])

    return(
        // <StepsWrapper loaded={loaded} stepGroupTitle={stepGroupTitle} title={t('general.open_pro_account')}>
        <StepsWrapper loaded={loaded} stepGroupTitle={stepGroupTitle} >
            {id === "identity" && <IdentityStep {...step_init} />}
            {id === "email" && <Email {...step_init}/>}
            {id === "phone" && <Phone {...step_init}/>}
            {id === "belgian-residence" && <BelgianResidence {...step_init}/>}
            {id === "legal-address" && <LegalAddress {...step_init}/>}
            {id === "date-of-birth" && <DateOfBirth {...step_init}/>}
            {id === "place-of-birth" && <PlaceOfBirth {...step_init}/>}
            {id === "nationality" && <Nationality {...step_init}/>}
            {id === "national-number" && <NationalNumber {...step_init}/>}
            {id === "marital-status" && <MaritalStatus {...step_init}/>}
            {id === "summary" && <SummaryPersoStep {...step_init}/>}
            {id === "end-flow" && <EndFlow title={""} description={""} />}
        </StepsWrapper>
    )
}


export default Steps



